module.exports = __webpack_public_path__ + "img/RLaudo+ opcoes.beb6473b.jpg";